export default __webpack_public_path__ + "static/media/Cattura12.51e6140d.jpg";